﻿import { ValgStateActionTypes, ValgState, UPDATE_VALG } from './Types';

export const initialState: ValgState = {
    inntekt: undefined,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                
                return {
                    ...state,
                    ...action.payload,
                };
            }
            default:
                return state;
        }
    }
}
